import { DefaultState } from 'store/types';
import { Filters } from 'store/types';

export const GET_USERS_ACTIVITY_REQUEST = 'GET_USERS_ACTIVITY_REQUEST';
export const GET_USERS_ACTIVITY_SUCCESS = 'GET_USERS_ACTIVITY_SUCCESS';
export const GET_USERS_ACTIVITY_FAILURE = 'GET_USERS_ACTIVITY_FAILURE';

export interface GetUsersActivityParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  },
  sorting: {
    id: string;
    order: string;
  }
}

export interface GetUsersActivityRow {
  id: string;
  email: string;
  role: string;
  status: string;
  fullName: string;
  addedReservation: number;
  editedReservation: number;
  addedLodging: number;
  editedLodging: number;
  addedRequest: number;
  editedRequest: number;
  bookedRequest: number;
}

export interface GetUsersActivityData {
  rows: GetUsersActivityRow[];
  totalCount: number;
}

export type GetUsersActivityState = DefaultState & {
  contents?: GetUsersActivityData;
};

interface GetUsersActivityRequest {
  type: typeof GET_USERS_ACTIVITY_REQUEST;
}

interface GetUsersActivitySuccess {
  type: typeof GET_USERS_ACTIVITY_SUCCESS;
  contents: GetUsersActivityData;
}

interface GetUsersActivityFailure {
  type: typeof GET_USERS_ACTIVITY_FAILURE;
}

export type GetUsersActivityActionTypes = GetUsersActivityRequest | GetUsersActivitySuccess | GetUsersActivityFailure;